/**
 * URL adapter for the Viewer. Reads /viewer/:studyId + ?series= from the
 * route and forwards them to <Viewer>. The :studyId param may be either
 * an EDGEPACS numeric id (digits only) or a DICOM StudyInstanceUID
 * (contains dots) — Viewer detects which form on its own.
 *
 * For RIS deep links specifically against a DICOMweb backend, a separate
 * `?uid=` query param can carry the StudyInstanceUID explicitly when
 * the path-style segment is awkward to escape.
 */
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import Viewer from '../components/Viewer';

export default function ViewerPage() {
  const { studyId } = useParams<{ studyId: string }>();
  const [searchParams] = useSearchParams();
  const requestedSeriesId = searchParams.get('series');
  const uidParam = searchParams.get('uid');
  const navigate = useNavigate();

  function goBack() {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }
    navigate('/worklist');
  }

  if (!studyId) return null;

  return (
    <Viewer
      studyId={studyId}
      studyInstanceUID={uidParam ?? undefined}
      requestedSeriesId={requestedSeriesId ? Number(requestedSeriesId) : undefined}
      onClose={goBack}
    />
  );
}
